import React, { useRef } from "react";
import { BlockTypeSelect, BoldItalicUnderlineToggles, codeBlockPlugin, codeMirrorPlugin, CreateLink, headingsPlugin, linkDialogPlugin, linkPlugin, listsPlugin, ListsToggle, markdownShortcutPlugin, MDXEditor, Separator, toolbarPlugin, UndoRedo, } from "@mdxeditor/editor";
import Icon from "./primitives/Icon";
export default function TriaphonMDXEditor(props) {
    const { field, isFullscreen, setIsFullscreen, defaultValue, disabled = false, className } = props;
    const initialMarkdown = defaultValue !== undefined ? defaultValue : field.value || "";
    const editorRef = useRef(null);
    const combinedClassName = ["triaphon-mdx-editor", className].filter(Boolean).join(" ");
    return (React.createElement(MDXEditor, { ref: editorRef, readOnly: disabled, markdown: initialMarkdown, onChange: (val) => {
            field.onChange(val);
        }, className: combinedClassName, plugins: [
            listsPlugin(),
            linkPlugin(),
            markdownShortcutPlugin(),
            toolbarPlugin({
                toolbarContents: () => disabled ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
                    React.createElement(BoldItalicUnderlineToggles, null),
                    React.createElement(Separator, null),
                    React.createElement(ListsToggle, null),
                    React.createElement(Separator, null),
                    React.createElement(CreateLink, null),
                    React.createElement(Separator, null),
                    React.createElement(BlockTypeSelect, null),
                    React.createElement(Separator, null),
                    React.createElement(UndoRedo, null),
                    setIsFullscreen && (React.createElement("button", { type: "button", onClick: () => setIsFullscreen(!isFullscreen), disabled: !!disabled, title: isFullscreen ? "Vollbild beenden" : "Vollbild", style: {
                            background: "none",
                            border: "none",
                            cursor: disabled ? "default" : "pointer",
                            padding: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: disabled ? 0.4 : 0.6,
                            borderRadius: "4px",
                            marginLeft: "auto",
                        } },
                        React.createElement(Icon, { margin: "0", icon: isFullscreen ? "fullscreenExit" : "fullscreen" }))))),
            }),
            linkDialogPlugin(),
            headingsPlugin(),
            codeBlockPlugin(),
            codeMirrorPlugin({
                codeBlockLanguages: {
                    js: "JavaScript",
                    ts: "TypeScript",
                },
            }),
        ] }));
}
